export interface IResponsible {
    id: number
    first_name: string
    last_name: string
    nickname: string
    dob: string
    dob_crm: string
    sex: string
    email: string   
    is_valid_email: string | null
    phone: string
    phone2: string
    street: string
    city: string
    state: string
    zip: string
    apartment: string
    lat: string
    lng: string
    wage: string
    commission: string
    role: string
    region_id: string
    department_id: string | null
    active: boolean
    logout: string
    api_token: string | null
    created_at: string
    updated_at: string
    country: string
    country_id: string
    capacity: string
    profit: string
    call_status: string
    twilio_phone: string
    force_logout: string
    work_with_parts: string
    avatar: string
    partsable_token: string
    general_ranking: string
    general_ranking_updated_at: string
    notification_settings: string
    goal_reminder: string
    session_id: string | null
    public_html: string
    public_profile_picture: string
    template_profile_active: string
    receive_sms_notifications: string
    company_config_id: string
    is_training: string
    old_email: string
    comments_email: string
    ad_guid: string | null
    ad_username: string | null
    sort_departments: string | null
    old_passwords: string
    force_reset_password: string
    first_login: string
    last_login_time: string
    poll_notifications: string
    public_nickname: string
    slack_sms: string
    slack_user: string
    about_me: string
    denied_read_recordings: string
    denied_read_customer_link: string
    denied_read_job_description: string
    tech_rating_type: string
    tech_rating_input: string
    hide_adl: string
    hide_cr: string
    hide_lead_description: string
    stripe_terminal_id: string | null
    google_auth_token: string | null
    sync_google_calendar: string
    timezone: string | null
    dashboard_pdf_doc: string
    hide_location: string
    hide_channel: string
    dashboard_pdf_viewed: string | null
    manual_score: string
    is_new_techapp: boolean
    slack_channel: string
    only_new_techapp: boolean
    can_merge_customer: string
    approve_payment: boolean
    approve_job: boolean
    is_allowed_manage_refunds: string
    is_allowed_override_tech_commission: string
    is_allowed_reset_service_delivered_date: string | null
    can_access_mso: string[]
    main_department: string
    merchant_data: {
        allow_payment_processor: boolean
        merchants: any[]
        credentials_for_departments: any[]
        default_merchant: string | null
        merchant_token: string | null
    }
    membership_access: {
        upgrade: boolean
        downgrade: boolean
        refund: boolean
        auto_renew_membership: boolean
        can_manage_membership_access: boolean
    }
    signature: string | null
    responsible_id: string | null
}

export class Responsible implements IResponsible {
    id: number = 0
    first_name: string = ''
    last_name: string = ''
    nickname: string = ''
    dob: string = ''
    dob_crm: string = ''
    sex: string = ''
    email: string = ''
    is_valid_email: string | null = null
    phone: string = ''
    phone2: string = ''
    street: string = ''
    city: string = ''
    state: string = ''
    zip: string = ''
    apartment: string = ''
    lat: string = ''
    lng: string = ''
    wage: string = ''
    commission: string = ''
    role: string = ''
    region_id: string = ''
    department_id: string | null = null
    active: boolean = false
    logout: string = ''
    api_token: string | null = null
    created_at: string = ''
    updated_at: string = ''
    country: string = ''
    country_id: string = ''
    capacity: string = ''
    profit: string = ''
    call_status: string = ''
    twilio_phone: string = ''
    force_logout: string = ''
    work_with_parts: string = ''
    avatar: string = ''
    partsable_token: string = ''
    general_ranking: string = ''
    general_ranking_updated_at: string = ''
    notification_settings: string = ''
    goal_reminder: string = ''
    session_id: string | null = null
    public_html: string = ''
    public_profile_picture: string = ''
    template_profile_active: string = ''
    receive_sms_notifications: string = ''
    company_config_id: string = ''
    is_training: string = ''
    old_email: string = ''
    comments_email: string = ''
    ad_guid: string | null = null
    ad_username: string | null = null
    sort_departments: string | null = null
    old_passwords: string = ''
    force_reset_password: string = ''
    first_login: string = ''
    last_login_time: string = ''
    poll_notifications: string = ''
    public_nickname: string = ''
    slack_sms: string = ''
    slack_user: string = ''
    about_me: string = ''
    denied_read_recordings: string = ''
    denied_read_customer_link: string = ''
    denied_read_job_description: string = ''
    tech_rating_type: string = ''
    tech_rating_input: string = ''
    hide_adl: string = ''
    hide_cr: string = ''
    hide_lead_description: string = ''
    stripe_terminal_id: string | null = null
    google_auth_token: string | null = null
    sync_google_calendar: string = ''
    timezone: string | null = null
    dashboard_pdf_doc: string = ''
    hide_location: string = ''
    hide_channel: string = ''
    dashboard_pdf_viewed: string | null = null
    manual_score: string = ''
    is_new_techapp: boolean = false
    slack_channel: string = ''
    only_new_techapp: boolean = false
    can_merge_customer: string = ''
    approve_payment: boolean = false
    approve_job: boolean = false
    is_allowed_manage_refunds: string = ''
    is_allowed_override_tech_commission: string = ''
    is_allowed_reset_service_delivered_date: string | null = null
    can_access_mso: string[] = []
    main_department: string = ''
    merchant_data: {
        allow_payment_processor: boolean
        merchants: any[]
        credentials_for_departments: any[]
        default_merchant: string | null
        merchant_token: string | null
    } = {
        allow_payment_processor: false,
        merchants: [],
        credentials_for_departments: [],
        default_merchant: null,
        merchant_token: null
    }
    membership_access: {
        upgrade: boolean
        downgrade: boolean
        refund: boolean
        auto_renew_membership: boolean
        can_manage_membership_access: boolean
    } = {
        upgrade: false,
        downgrade: false,
        refund: false,
        auto_renew_membership: false,
        can_manage_membership_access: false
    }
    signature: string | null = null
    responsible_id: string | null = null

    constructor(o: IResponsible) {
        if (o) {
            this.id = o.id
            this.first_name = o.first_name
            this.last_name = o.last_name
            this.nickname = o.nickname
            this.dob = o.dob
            this.dob_crm = o.dob_crm
            this.sex = o.sex
            this.email = o.email
            this.is_valid_email = o.is_valid_email
            this.phone = o.phone
            this.phone2 = o.phone2
            this.street = o.street
            this.city = o.city
            this.state = o.state
            this.zip = o.zip
            this.apartment = o.apartment
            this.lat = o.lat
            this.lng = o.lng
            this.wage = o.wage
            this.commission = o.commission
            this.role = o.role
            this.region_id = o.region_id
            this.department_id = o.department_id
            this.active = o.active
            this.logout = o.logout
            this.api_token = o.api_token
            this.created_at = o.created_at
            this.updated_at = o.updated_at
            this.country = o.country
            this.country_id = o.country_id
            this.capacity = o.capacity
            this.profit = o.profit
            this.call_status = o.call_status
            this.twilio_phone = o.twilio_phone
            this.force_logout = o.force_logout
            this.work_with_parts = o.work_with_parts
            this.avatar = o.avatar
            this.partsable_token = o.partsable_token
            this.general_ranking = o.general_ranking
            this.general_ranking_updated_at = o.general_ranking_updated_at
            this.notification_settings = o.notification_settings
            this.goal_reminder = o.goal_reminder
            this.session_id = o.session_id
            this.public_html = o.public_html
            this.public_profile_picture = o.public_profile_picture
            this.template_profile_active = o.template_profile_active
            this.receive_sms_notifications = o.receive_sms_notifications
            this.company_config_id = o.company_config_id
            this.is_training = o.is_training
            this.old_email = o.old_email
            this.comments_email = o.comments_email
            this.ad_guid = o.ad_guid
            this.ad_username = o.ad_username
            this.sort_departments = o.sort_departments
            this.old_passwords = o.old_passwords
            this.force_reset_password = o.force_reset_password
            this.first_login = o.first_login
            this.last_login_time = o.last_login_time
            this.poll_notifications = o.poll_notifications
            this.public_nickname = o.public_nickname
            this.slack_sms = o.slack_sms
            this.slack_user = o.slack_user
            this.about_me = o.about_me
            this.denied_read_recordings = o.denied_read_recordings
            this.denied_read_customer_link = o.denied_read_customer_link
            this.denied_read_job_description = o.denied_read_job_description
            this.tech_rating_type = o.tech_rating_type
            this.tech_rating_input = o.tech_rating_input
            this.hide_adl = o.hide_adl
            this.hide_cr = o.hide_cr    
            this.hide_lead_description = o.hide_lead_description
            this.stripe_terminal_id = o.stripe_terminal_id
            this.google_auth_token = o.google_auth_token
            this.sync_google_calendar = o.sync_google_calendar
            this.timezone = o.timezone
            this.dashboard_pdf_doc = o.dashboard_pdf_doc
            this.hide_location = o.hide_location
            this.hide_channel = o.hide_channel
            this.dashboard_pdf_viewed = o.dashboard_pdf_viewed
            this.manual_score = o.manual_score
            this.is_new_techapp = o.is_new_techapp
            this.slack_channel = o.slack_channel
            this.only_new_techapp = o.only_new_techapp
            this.can_merge_customer = o.can_merge_customer
            this.approve_payment = o.approve_payment
            this.approve_job = o.approve_job
            this.is_allowed_manage_refunds = o.is_allowed_manage_refunds
            this.is_allowed_override_tech_commission = o.is_allowed_override_tech_commission
            this.is_allowed_reset_service_delivered_date = o.is_allowed_reset_service_delivered_date
            this.can_access_mso = o.can_access_mso
            this.main_department = o.main_department
            this.merchant_data = o.merchant_data
            this.membership_access = o.membership_access
            this.signature = o.signature
            this.responsible_id = o.responsible_id
        }
    }


    public get Id(): number {
        return this.id
    }
    public get FirstName(): string {
        return this.first_name
    }
    public get LastName(): string {
        return this.last_name
    }
    public get Nickname(): string {
        return this.nickname
    }
    public get Dob(): string {
        return this.dob
    }
    public get DobCrm(): string {
        return this.dob_crm
    }
    public get Sex(): string {
        return this.sex
    }
    public get Email(): string {
        return this.email
    }
    public get IsValidEmail(): string | null {
        return this.is_valid_email
    }
    public get Phone(): string {
        return this.phone
    }
    public get Phone2(): string {
        return this.phone2
    }
    public get Street(): string {
        return this.street
    }
    public get City(): string {
        return this.city
    }
    public get State(): string {
        return this.state
    }
    public get Zip(): string {
        return this.zip
    }
    public get Apartment(): string {
        return this.apartment
    }
    public get Lat(): string {
        return this.lat
    }   
    public get Lng(): string {
        return this.lng
    }
    public get Wage(): string {
        return this.wage
    }
    public get Commission(): string {
        return this.commission
    }
    public get Role(): string {
        return this.role
    }
    public get RegionId(): string {
        return this.region_id
    }
    public get DepartmentId(): string | null {
        return this.department_id
    }
    public get Active(): boolean {
        return this.active
    }
    public get Logout(): string {
        return this.logout
    }
    public get ApiToken(): string | null {
        return this.api_token
    }
    public get CreatedAt(): string {
        return this.created_at
    }
    public get UpdatedAt(): string {
        return this.updated_at
    }
    public get Country(): string {
        return this.country
    }
    public get CountryId(): string {
        return this.country_id
    }
    public get Capacity(): string {
        return this.capacity
    }
    public get Profit(): string {
        return this.profit
    }
    public get CallStatus(): string {
        return this.call_status
    }
    public get TwilioPhone(): string {
        return this.twilio_phone
    }
    public get ForceLogout(): string {
        return this.force_logout
    }
    public get WorkWithParts(): string {
        return this.work_with_parts
    }
    public get Avatar(): string {
        return this.avatar
    }
    public get PartsableToken(): string {
        return this.partsable_token
    }
    public get GeneralRanking(): string {
        return this.general_ranking
    }
    public get GeneralRankingUpdatedAt(): string {
        return this.general_ranking_updated_at
    }
    public get NotificationSettings(): string {
        return this.notification_settings
    }
    public get GoalReminder(): string {
        return this.goal_reminder
    }
    public get SessionId(): string | null {
        return this.session_id
    }
    public get PublicHtml(): string {
        return this.public_html
    }
    public get PublicProfilePicture(): string {
        return this.public_profile_picture
    }
    public get TemplateProfileActive(): string {
        return this.template_profile_active
    }
    public get ReceiveSmsNotifications(): string {
        return this.receive_sms_notifications
    }
    public get CompanyConfigId(): string {
        return this.company_config_id
    }
    public get IsTraining(): string {
        return this.is_training
    }
    public get OldEmail(): string {
        return this.old_email
    }
    public get CommentsEmail(): string {
        return this.comments_email
    }
    public get AdGuid(): string | null {
        return this.ad_guid
    }
    public get AdUsername(): string | null {
        return this.ad_username
    }
    public get SortDepartments(): string | null {
        return this.sort_departments
    }
    public get OldPasswords(): string {
        return this.old_passwords
    }
    public get ForceResetPassword(): string {
        return this.force_reset_password
    }
    public get FirstLogin(): string {
        return this.first_login
    }
    public get LastLoginTime(): string {
        return this.last_login_time
    }
    public get PollNotifications(): string {
        return this.poll_notifications
    }
    public get PublicNickname(): string {
        return this.public_nickname
    }
    public get SlackSms(): string {
        return this.slack_sms
    }
    public get SlackUser(): string {
        return this.slack_user
    }
    public get AboutMe(): string {
        return this.about_me
    }
    public get DeniedReadRecordings(): string {
        return this.denied_read_recordings
    }
    public get DeniedReadCustomerLink(): string {
        return this.denied_read_customer_link
    }
    public get DeniedReadJobDescription(): string {
        return this.denied_read_job_description
    }
    public get TechRatingType(): string {   
        return this.tech_rating_type
    }
    public get TechRatingInput(): string {
        return this.tech_rating_input
    }
    public get HideAdl(): string {
        return this.hide_adl
    }
    public get HideCr(): string {
        return this.hide_cr
    }
    public get HideLeadDescription(): string {
        return this.hide_lead_description
    }
    public get StripeTerminalId(): string | null {
        return this.stripe_terminal_id
    }
    public get GoogleAuthToken(): string | null {   
        return this.google_auth_token
    }
    public get SyncGoogleCalendar(): string {       
        return this.sync_google_calendar
    }
    public get Timezone(): string | null {
        return this.timezone
    }
    public get DashboardPdfDoc(): string {      
        return this.dashboard_pdf_doc
    }
    public get HideLocation(): string {
        return this.hide_location
    }   
    public get HideChannel(): string {
        return this.hide_channel
    }
    public get DashboardPdfViewed(): string | null {
        return this.dashboard_pdf_viewed
    }
    public get ManualScore(): string {
        return this.manual_score
    }
    public get IsNewTechapp(): boolean {
        return this.is_new_techapp
    }
    public get SlackChannel(): string {
        return this.slack_channel
    }
    public get OnlyNewTechapp(): boolean {
        return this.only_new_techapp
    }
    public get CanMergeCustomer(): string {
        return this.can_merge_customer
    }
    public get ApprovePayment(): boolean {
        return this.approve_payment
    }
    public get ApproveJob(): boolean {
        return this.approve_job
    }
    public get IsAllowedManageRefunds(): string {
        return this.is_allowed_manage_refunds
    }
    public get IsAllowedOverrideTechCommission(): string {
        return this.is_allowed_override_tech_commission
    }
    public get IsAllowedResetServiceDeliveredDate(): string | null {
        return this.is_allowed_reset_service_delivered_date
    }
    public get CanAccessMso(): string[] {
        return this.can_access_mso
    }
    public get MainDepartment(): string {
        return this.main_department
    }
    public get MerchantData(): {
        allow_payment_processor: boolean
        merchants: any[]
        credentials_for_departments: any[]
        default_merchant: string | null
        merchant_token: string | null
    } {
        return this.merchant_data
    }
    public get MembershipAccess(): {
        upgrade: boolean
        downgrade: boolean
        refund: boolean
        auto_renew_membership: boolean
        can_manage_membership_access: boolean
    } {
        return this.membership_access
    }
    public get Signature(): string | null {
        return this.signature
    }
    public get ResponsibleId(): string | null {
        return this.responsible_id
    }
    public set FirstName(first_name: string) {
        this.first_name = first_name
    }
    public set LastName(last_name: string) {
        this.last_name = last_name
    }
    public set Nickname(nickname: string) {
        this.nickname = nickname
    }
    public set Dob(dob: string) {
        this.dob = dob
    }
    public set DobCrm(dob_crm: string) {
        this.dob_crm = dob_crm          
    }   
    public set Sex(sex: string) {
        this.sex = sex 
    }
    public set Email(email: string) {
        this.email = email
    }
    public set IsValidEmail(is_valid_email: string | null) {
        this.is_valid_email = is_valid_email
    }
    public set Phone(phone: string) {
        this.phone = phone
    }
    public set Phone2(phone2: string) {
        this.phone2 = phone2
    }
    public set Street(street: string) {
        this.street = street
    }
    public set City(city: string) {
        this.city = city
    }
    public set State(state: string) {
        this.state = state
    }
    public set Zip(zip: string) {
        this.zip = zip
    }
    public set Apartment(apartment: string) {
        this.apartment = apartment
    }
    public set Lat(lat: string) {
        this.lat = lat
    }
    public set Lng(lng: string) {
        this.lng = lng
    }
    public set Wage(wage: string) { 
        this.wage = wage
    }
    public set Commission(commission: string) {
        this.commission = commission
    }
    public set Role(role: string) {
        this.role = role
    }           
    public set RegionId(region_id: string) {
        this.region_id = region_id
    }
    public set DepartmentId(department_id: string | null) {
        this.department_id = department_id
    }
    public set Active(active: boolean) {
        this.active = active
    }
    public set Logout(logout: string) {
        this.logout = logout
    }
    public set ApiToken(api_token: string | null) {
        this.api_token = api_token
    }
    public set CreatedAt(created_at: string) {
        this.created_at = created_at
    }
    public set UpdatedAt(updated_at: string) {
        this.updated_at = updated_at
    }
    public set Country(country: string) {
        this.country = country
    }
    public set CountryId(country_id: string) {
        this.country_id = country_id
    }
    public set Capacity(capacity: string) {
        this.capacity = capacity
    }
    public set Profit(profit: string) {
        this.profit = profit
    }
    public set CallStatus(call_status: string) {
        this.call_status = call_status
    }
    public set TwilioPhone(twilio_phone: string) {
        this.twilio_phone = twilio_phone
    }
    public set ForceLogout(force_logout: string) {
        this.force_logout = force_logout
    }
    public set WorkWithParts(work_with_parts: string) {
        this.work_with_parts = work_with_parts
    }
    public set Avatar(avatar: string) {
        this.avatar = avatar
    }
    public set PartsableToken(partsable_token: string) {
        this.partsable_token = partsable_token
    }
    public set GeneralRanking(general_ranking: string) {
        this.general_ranking = general_ranking
    }
    public set GeneralRankingUpdatedAt(general_ranking_updated_at: string) {
        this.general_ranking_updated_at = general_ranking_updated_at
    }
    public set NotificationSettings(notification_settings: string) {    
        this.notification_settings = notification_settings
    }
    public set GoalReminder(goal_reminder: string) {
        this.goal_reminder = goal_reminder
    }
    public set SessionId(session_id: string | null) {
        this.session_id = session_id
    }
    public set PublicHtml(public_html: string) {
        this.public_html = public_html
    }
    public set PublicProfilePicture(public_profile_picture: string) {
        this.public_profile_picture = public_profile_picture
    }
    public set TemplateProfileActive(template_profile_active: string) {
        this.template_profile_active = template_profile_active
    }
    public set ReceiveSmsNotifications(receive_sms_notifications: string) {
        this.receive_sms_notifications = receive_sms_notifications
    }
    public set CompanyConfigId(company_config_id: string) { 
        this.company_config_id = company_config_id
    }
    public set IsTraining(is_training: string) {
        this.is_training = is_training
    }
    public set OldEmail(old_email: string) {
        this.old_email = old_email
    }
    public set CommentsEmail(comments_email: string) {
        this.comments_email = comments_email
    }
    public set AdGuid(ad_guid: string | null) {
        this.ad_guid = ad_guid
    }
    public set AdUsername(ad_username: string | null) {
        this.ad_username = ad_username
    }
    public set SortDepartments(sort_departments: string | null) {
        this.sort_departments = sort_departments
    }
    public set OldPasswords(old_passwords: string) {
        this.old_passwords = old_passwords
    }
    public set ForceResetPassword(force_reset_password: string) {
        this.force_reset_password = force_reset_password
    }
    public set FirstLogin(first_login: string) {
        this.first_login = first_login
    }
    public set LastLoginTime(last_login_time: string) { 
        this.last_login_time = last_login_time
    }
    public set PollNotifications(poll_notifications: string) {
        this.poll_notifications = poll_notifications
    }
    public set PublicNickname(public_nickname: string) {
        this.public_nickname = public_nickname
    }
    public set SlackSms(slack_sms: string) {
        this.slack_sms = slack_sms
    }
    public set SlackUser(slack_user: string) {
        this.slack_user = slack_user
    }
    public set AboutMe(about_me: string) {
        this.about_me = about_me
    }
    public set DeniedReadRecordings(denied_read_recordings: string) {
        this.denied_read_recordings = denied_read_recordings
    }
    public set DeniedReadCustomerLink(denied_read_customer_link: string) {
        this.denied_read_customer_link = denied_read_customer_link
    }
    public set DeniedReadJobDescription(denied_read_job_description: string) {  
        this.denied_read_job_description = denied_read_job_description
    }
    public set TechRatingType(tech_rating_type: string) {
        this.tech_rating_type = tech_rating_type
    }
    public set TechRatingInput(tech_rating_input: string) {
        this.tech_rating_input = tech_rating_input
    }
    public set HideAdl(hide_adl: string) {
        this.hide_adl = hide_adl
    }
    public set HideCr(hide_cr: string) {
        this.hide_cr = hide_cr
    }
    public set HideLeadDescription(hide_lead_description: string) { 
        this.hide_lead_description = hide_lead_description
    }
    public set StripeTerminalId(stripe_terminal_id: string | null) {
        this.stripe_terminal_id = stripe_terminal_id
    }
    public set GoogleAuthToken(google_auth_token: string | null) {
        this.google_auth_token = google_auth_token
    }
    public set SyncGoogleCalendar(sync_google_calendar: string) {
        this.sync_google_calendar = sync_google_calendar
    }
    public set Timezone(timezone: string | null) {
        this.timezone = timezone
    }
    public set DashboardPdfDoc(dashboard_pdf_doc: string) {
        this.dashboard_pdf_doc = dashboard_pdf_doc
    }
    public set HideLocation(hide_location: string) {
        this.hide_location = hide_location
    }       
    public set HideChannel(hide_channel: string) {
        this.hide_channel = hide_channel
    }
    public set DashboardPdfViewed(dashboard_pdf_viewed: string | null) {
        this.dashboard_pdf_viewed = dashboard_pdf_viewed
    }
    public set ManualScore(manual_score: string) {  
        this.manual_score = manual_score
    }
    public set IsNewTechapp(is_new_techapp: boolean) {
        this.is_new_techapp = is_new_techapp
    }
    public set SlackChannel(slack_channel: string) {
        this.slack_channel = slack_channel
    }
    public set OnlyNewTechapp(only_new_techapp: boolean) {
        this.only_new_techapp = only_new_techapp
    }
    public set CanMergeCustomer(can_merge_customer: string) {
        this.can_merge_customer = can_merge_customer
    }
    public set ApprovePayment(approve_payment: boolean) {   
        this.approve_payment = approve_payment
    }
    public set ApproveJob(approve_job: boolean) {   
        this.approve_job = approve_job
    }
    public set IsAllowedManageRefunds(is_allowed_manage_refunds: string) {
        this.is_allowed_manage_refunds = is_allowed_manage_refunds
    }
    public set IsAllowedOverrideTechCommission(is_allowed_override_tech_commission: string) {
        this.is_allowed_override_tech_commission = is_allowed_override_tech_commission
    }
    public set IsAllowedResetServiceDeliveredDate(is_allowed_reset_service_delivered_date: string | null) {
        this.is_allowed_reset_service_delivered_date = is_allowed_reset_service_delivered_date
    }
    public set CanAccessMso(can_access_mso: string[]) {
        this.can_access_mso = can_access_mso
    }
    public set MainDepartment(main_department: string) {
        this.main_department = main_department
    }
    public set MerchantData(merchant_data: {        
        allow_payment_processor: boolean
        merchants: any[]
        credentials_for_departments: any[]
        default_merchant: string | null
        merchant_token: string | null
    }) {
        this.merchant_data = merchant_data
    }
    public set MembershipAccess(membership_access: {
        upgrade: boolean
        downgrade: boolean
        refund: boolean
        auto_renew_membership: boolean
        can_manage_membership_access: boolean
    }) {
        this.membership_access = membership_access
    }
    public set Signature(signature: string | null) {
        this.signature = signature
    }
    public set ResponsibleId(responsible_id: string | null) {
        this.responsible_id = responsible_id
    }
    public get FullName(): string {
        return `${this.first_name} ${this.nickname} ${this.last_name}`
    }
}
